import * as tslib_1 from "tslib";
import ivyPlayer from '../../commons/ivyPlayer.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
let SpellGroup = class SpellGroup extends Vue {
    constructor() {
        super(...arguments);
        this.pageIndex = 1;
        this.videoPlaying = false;
        this.timer = '';
    }
    async created() { }
    pageChange(index) {
        this.pageIndex = index + 1;
    }
    playVideo() {
        // 播放视频
        this.videoPlaying = true;
        document.querySelector('.ivy-btn-play').click();
    }
    closeVideo() {
        // 关闭播放
        this.videoPlaying = false;
        this.newTime = new Date().getTime();
    }
};
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "spuData", void 0);
tslib_1.__decorate([
    Prop()
], SpellGroup.prototype, "goldShow", void 0);
SpellGroup = tslib_1.__decorate([
    Component({
        components: {
            ivyPlayer,
        },
    })
], SpellGroup);
export default SpellGroup;
